import { Button, TextField } from "@mui/material";
import { Alert } from "react-bootstrap";

function EditCategoryModal(props) {
  const {
    submittingEditData,
    setAddCategoryData,
    updateCategory,
    setCategoryEditData,
    categoryEditData,
    error,
    setError,
  } = props;

  return (
    <div>
      <>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 100,
          }}
        ></div>
        <Alert
          variant="light"
          // onClose={() => setShowSuccessMessage(false)}
          dismissible={false}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: '456px',
            width: 'calc(100vw - 8vw)',
            height: "auto",
            zIndex: 1000,
          }}
        >
          <Alert.Heading
            style={{
              fontSize: "1.5rem",
              color: "#000000",
              textAlign: "center",
            }}
          >
            Edit category
          </Alert.Heading>
          <div className="my-3">
            <TextField
              placeholder="Enter Category"
              name="subcategory"
              value={categoryEditData?.label}
              onChange={(e) =>
                setCategoryEditData((pre) => ({
                  ...pre,
                  label: e.target.value,
                }))
              }
              fullWidth
              disabled={submittingEditData}
              margin="normal"
              sx={{
                marginTop: 0,
                "& .MuiInputLabel-root": {
                  padding: "0 4px",
                  top: "-8px",
                },
                "& .MuiInputBase-input": {
                  padding: " 6.5px 14px",
                },
                "& .Mui-error": {
                  marginLeft: "0px",
                  color: "#dc3545",
                  fontSize: "16px",
                },
              }}
            />
          </div>
          {error && <div className="error-message text-danger">{error}</div>}
          <div
            className="d-flex justify-content-end"
            style={{ display: "grid", gridGap: "10px" }}
          >
            <Button
              style={{ color: "white" }}
              className="btn bg-info mr-2 w-auto text-capitalize"
              onClick={() => {
                updateCategory();
              }}
            >
              {submittingEditData ? "Submitting..." : "Submit"}
            </Button>
            <Button
              className="btn bg-secondary btn-secondary text-white w-auto text-capitalize"
              onClick={() => {
                setAddCategoryData(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </Alert>
      </>
    </div>
  );
}

export default EditCategoryModal;
